import React, { useState } from "react";
import PropTypes from "prop-types";
import SlotSelectorDate from "./SlotSelectorDate";
import SlotSelectorTime from "./SlotSelectorTime";

const SlotSelectorDatetime = (props) => {
    if (!props.slots.filter((item) => item.free).length)
        return <>Keine Lieferslots verfügbar</>;

    const [currentDate, setCurrentDate] = useState(
        props.slots.filter((item) => item.free)[0].moment.substr(0, 10)
    );
    const [currentDatetime, setCurrentDatetime] = useState(
        props.slots.filter((item) => item.free)[0].moment
    );

    const selectDate = (date) => {
        setCurrentDate(date);
        let times = props.slots.filter(
            (time) => time.moment.substr(0, 10) === date && time.free
        );
        if (!times.length) {
            setCurrentDatetime("");
            return;
        }
        setCurrentDatetime(times[0].moment);
    };

    return (
        <>
            <p id="delivery-date-field" className="form-row form-row-first">
                <label htmlFor="delivery-date">Tag</label>
                <span className="woocommerce-select-wrapper">
                    <SlotSelectorDate
                        slots={props.slots}
                        currentDate={currentDate}
                        selectDate={selectDate}
                    />
                </span>
            </p>
            <p id="delivery-datetime-field" className="form-row form-row-last">
                <label htmlFor="delivery-datetime">Uhrzeit</label>
                <span className="woocommerce-select-wrapper">
                    <SlotSelectorTime
                        slots={props.slots}
                        currentDate={currentDate}
                        currentDatetime={currentDatetime}
                        setCurrentDatetime={setCurrentDatetime}
                    />
                </span>
            </p>
        </>
    );
};

export const DeliveryDatetimePropType = {
    free: PropTypes.bool,
    moment: PropTypes.string,
};

SlotSelectorDatetime.propTypes = {
    slots: PropTypes.arrayOf(PropTypes.shape(DeliveryDatetimePropType)),
};

export default SlotSelectorDatetime;
